module.exports = __webpack_public_path__ + "assets/img/00011.46a944b2.png";